import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subject } from 'rxjs';
import { shareReplay, takeUntil } from 'rxjs/operators';
import { AuthService, UserInfo } from '../auth.service';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
    private destroying$ = new Subject<void>();

    title = 'Lighthouse Frontend';
    user: UserInfo | null = null;
    loadingUser = true;

    constructor(private auth: AuthService) {}

    ngOnInit(): void {
        this.auth
            .getUser()
            .pipe(takeUntil(this.destroying$))
            .subscribe((u) => {
                this.user = u;
                this.loadingUser = false;
            });

        this.auth
            .loadUser()
            .pipe(shareReplay())
            .subscribe({
                error: () => {
                    this.loadingUser = false;
                },
            });
    }

    login(): void {
        this.auth.startLogin();
    }

    logout(): void {
        this.auth.startLogout();
    }

    ngOnDestroy(): void {
        this.destroying$.next();
        this.destroying$.complete();
    }

    animationData(outlet: RouterOutlet) {
        return outlet?.activatedRouteData?.['animation'];
    }
}
